
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";

export const WorksheetEmpty: React.FC = () => {
  return (
    <TableRow>
      <TableCell colSpan={8} className="text-center py-8 text-muted-foreground">
        ไม่พบข้อมูลชีทที่ตรงกับการค้นหา
      </TableCell>
    </TableRow>
  );
};
